import InternalSearchExplorePage from 'src/modules/Opportunities/pages/Explore/Components/Pages/InternalSearchExplorePage';

export default InternalSearchExplorePage;
